import { createColumnHelper } from '@tanstack/react-table';
import Button from 'components/button';
import Card from 'components/card';
import SimpleTable from 'components/simpleTable';
import TableComponent from 'components/table';
import Header from 'components/text/header';
import { HiArrowRight } from 'react-icons/hi';
import { MdCheckCircle, MdCancel, MdOutlineError } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { UserWallet } from 'types';

type Transactions = {
  type: string;
  bookingId: string;
  requestId: string;
  amount: string;
  date: string;
  state: string;
};

const transactionsColumnHelper = createColumnHelper<Transactions>();
const transactionsColumns = [
  transactionsColumnHelper.accessor('type', {
    id: 'type',
    header: () => <p className="  ">TYPE</p>,
    cell: (info) => <p className="  ">{info.getValue() || '-'}</p>,
  }),
  transactionsColumnHelper.accessor('amount', {
    id: 'transactionAmount',
    header: () => <p className="  ">AMOUNT (PKR)</p>,
    cell: (info) => <p className="  ">{info.getValue()}</p>,
  }),
  transactionsColumnHelper.accessor('date', {
    id: 'transactionDate',
    header: () => <p className="  ">DATE</p>,
    cell: (info) => <p className="  ">{info.getValue()?.substring(0, 10)}</p>,
  }),
  transactionsColumnHelper.accessor('state', {
    id: 'transactionStatus',
    header: () => <p className="  ">STATUS</p>,
    cell: (info) => (
      <div className="flex items-center">
        {info.getValue() === 'successful' ? (
          <MdCheckCircle className="me-1 text-green-500 dark:text-green-300" />
        ) : info.getValue() === 'unsuccessful' ? (
          <MdCancel className="me-1 text-red-500 dark:text-red-300" />
        ) : info.getValue() === 'pending' ? (
          <MdOutlineError className="me-1 text-amber-500 dark:text-amber-300" />
        ) : null}
        <p className="text-md font-medium capitalize">{info.getValue()}</p>
      </div>
    ),
  }),
  transactionsColumnHelper.accessor('type', {
    id: 'link',
    header: () => <p className="">DETAILS</p>,
    cell: (info) => {
      const type = info.getValue();
      return (
        <Link
          target="_blank"
          to={
            type === 'cashout'
              ? `/admin/withdrawal-request/${info.row.original.requestId}`
              : `/admin/booking/${info.row.original.bookingId}`
          }
        >
          <Button type="icon">
            <HiArrowRight />
          </Button>
        </Link>
      );
    },
  }),
];
const WalletData = ({ wallet }: { wallet: UserWallet }) => {
  const { availableAmount, pendingCashout, bankAccounts, transactions } =
    wallet;

  const fetchData = (options: { pageIndex: number; pageSize: number }) => {
    const { pageIndex, pageSize } = options;
    const startIndex = pageIndex * pageSize;
    const endIndex = startIndex + pageSize;

    const paginatedData = transactions.slice(startIndex, endIndex);
    const pageCount = Math.ceil(transactions.length / pageSize);

    return { rows: paginatedData, pageCount };
  };

  return (
    <>
      <Card extra="m4 p-4 border-2 border-blue-400 bg-gray-50">
        <SimpleTable
          header="Wallet Details"
          data={[
            { key: 'Available Amount', value: 'PKR ' + availableAmount },
            { key: 'Pending Cashout', value: 'PKR ' + pendingCashout },
          ]}
        />
        {bankAccounts?.length > 0 && (
          <Header extraClasses="ml-3">Bank Accounts</Header>
        )}
        {bankAccounts?.map((bankAccount: any) => (
          <SimpleTable
            data={[
              { key: 'bank', value: bankAccount.bank },
              { key: 'name', value: bankAccount.title },
              { key: 'number', value: bankAccount.iban },
            ]}
            extraClasses="pb-2  border-b border-gray-100 "
          />
        ))}
      </Card>
      <TableComponent
        header="Transactions"
        fetchData={fetchData}
        columns={transactionsColumns}
      />
    </>
  );
};
export default WalletData;
